import { theme } from "../Styles/theme";

const LoveIcon = ({
  style = { height: "1.75vh", width: "1.75vh" },
  fillIcon,
}) => {
  return (
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        clip-rule="evenodd"
        d={
          fillIcon
            ? "m.25 6.37988c0-3.17563 2.57436-5.749997 5.75-5.749997 1.55491 0 2.96569.617737 4 1.619387 1.0343-1.00165 2.4451-1.619387 4-1.619387 3.1756 0 5.75 2.574367 5.75 5.749997 0 2.57461-1.4733 5.20822-3.1426 7.39132-1.6898 2.2101-3.6837 4.0902-4.924 5.1769-.971.8508-2.39577.8508-3.36684 0-1.24029-1.0867-3.23418-2.9668-4.92399-5.1769-1.66923-2.1831-3.14257-4.81671-3.14257-7.39132z"
            : "m6 2.12988c-2.34721 0-4.25 1.90279-4.25 4.25 0 2.05805 1.20934 4.35522 2.83417 6.48022 1.60424 2.0982 3.51575 3.9038 4.72089 4.9597.40529.3551.98454.3551 1.38984 0 1.2052-1.0559 3.1167-2.8615 4.7209-4.9597 1.6249-2.125 2.8342-4.42217 2.8342-6.48022 0-2.34721-1.9028-4.25-4.25-4.25-1.3898 0-2.6237.66629-3.4004 1.70002l-.5996.79809-.59962-.79809c-.77667-1.03373-2.0106-1.70002-3.40038-1.70002zm-5.75 4.25c0-3.17563 2.57436-5.749997 5.75-5.749997 1.55491 0 2.96569.617737 4 1.619387 1.0343-1.00165 2.4451-1.619387 4-1.619387 3.1756 0 5.75 2.574367 5.75 5.749997 0 2.57461-1.4733 5.20822-3.1426 7.39132-1.6898 2.2101-3.6837 4.0902-4.924 5.1769-.971.8508-2.39577.8508-3.36684 0-1.24029-1.0867-3.23418-2.9668-4.92399-5.1769-1.66923-2.1831-3.14257-4.81671-3.14257-7.39132z"
        }
        fill-rule="evenodd"
        fill={`${theme.main}`}
      />
    </svg>
  );
};

export default LoveIcon;
